{
  "version": 1,
  "asset_id": "38054f37-6b96-42f0-9142-f78c7759b8cf",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/38054f37-6b96-42f0-9142-f78c7759b8cf/dilated-pouch-boxed-en-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/38054f37-6b96-42f0-9142-f78c7759b8cf/dilated-pouch-boxed-en-800.jpg",
  "original_filename": "dilated-pouch-boxed-en-800.jpg",
  "size": 73398,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:27:46Z"
}
